import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export interface Project {
  code: string;
  name: string;
}

interface SelectedBrandsChipsProps {
  selectedBrands: Project[];
  onDelete: (code: string | undefined) => void;
}

export default function SelectedBrandsChips({
  selectedBrands,
  onDelete,
}: SelectedBrandsChipsProps) {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {selectedBrands.map((project) => (
        <div
          key={project?.code}
          className="flex items-center bg-gray-200 text-gray-800 text-sm font-medium px-3 py-1 rounded-full"
        >
          <span>{`${project?.code} - ${project?.name}`}</span>
          <button
            type="button"
            onClick={() => onDelete(project.code)}
            className="ml-1.5 flex-shrink-0 rounded-full p-0.5 text-gray-500 hover:bg-gray-300 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            aria-label={`Remove ${project?.name}`}
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
